import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Button, Form } from 'semantic-ui-react';
import Logo from './../common/Logo';
import {Link} from 'react-router-dom';
import {updateUserLocation} from './../../actions/appActions';
class HomeScreen extends React.Component {

    constructor(props){
        super(props);
        this.locationCheck = this.locationCheck.bind(this);

        this.state = {
            findCharity : false,
        }


    }
    componentWillMount(){ }
    
    componentDidMount(){


    }

    locationCheck(to){

        console.log(to)
        if(!this.props.userLocation){
            navigator.geolocation.getCurrentPosition(
                (position)=>{
                    this.props.updateUserLocation({lat : position.coords.latitude, lng : position.coords.longitude});

                },
                ()=>{
                    console.log('user decided not to share their location');
                }
            );

            this.props.history.push(to)

            //
        } else {
            console.log(this.props)
            this.props.history.push(to)
        }

    }

    render(){

        const renderCharitySearch = ()=>{
            if(this.state.findCharity) {
                return (
                    <Form>
                        <Form.Input
                            fluid
                            placeholder="SEARCH FOR THE CHARITY YOU WANT TO SUPPORT"/>
                    </Form>
                )
            } else {
                    return (
                        <Button
                            color="blue"
                            inverted
                            to="/dontate"
                            fluid
                            size="large"
                            onClick={()=>{this.setState({findCharity: true})}}
                        >FIND A CHARITY</Button>
                    )
                }
            }


        return (
            <div className="HomeScreen">
                <div className="HomeScreen-Wrap">
                    <Logo />
                    <div className="HomeScreen-ButtonRow">
                        <Button
                            style={{marginRight:5}}
                            color="blue"
                            onClick={()=>{this.locationCheck('/donate')}}
                            fluid
                            size="large"
                        >DONATE SOMETHING</Button>
                        <Button
                            size="large"
                            style={{marginLeft:5}}
                            color="blue"
                            onClick={()=>{this.locationCheck('/volunteer')}}
                            fluid
                        >VOLUNTEER</Button>
                    </div>
                    <div className="HomeScreen-ButtonRow">
                        {renderCharitySearch()}
                    </div>
                </div>





            </div>
        )
    }
}

HomeScreen.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        userLocation : state.app.userLocation
    };
}

export default  connect(mapStateProps, {  updateUserLocation})(HomeScreen);



// WEBPACK FOOTER //
// ./src/components/screens/HomeScreen.js